module.exports = __webpack_public_path__ + "img/audio-volume-medium-symbolic.e96fa056.svg";